import ReferencesService from "../services/references.sevice";
import i18n from "../lang/lang";

const state = {
	excelFields: [
		{
			key: 'id',
			label: '№',
			stickyColumn: true,
			sort: false,
			class: ['text-center', 'z']
		},
		// {
		// 	key: 'barcode',
		// 	sortable: true,
		// 	label: 'Barcode',
		// 	class: ['text-center', 'z']
		// },
		// {
		// 	key: 'price',
		// 	label: 'Price',
		// 	sortable: true,
		// 	visible: true,
		// 	changebale: true
		// }
		{
			key: 'itemName',
			label: i18n.t('prices.item.details'),
			'class': 'width26percent',
		},
		{
			key: 'barcode',
			label: i18n.t('goods.special-barcode'),

		},
		{
			key: 'multiBarcode',
			label: i18n.t('goods.barcode'),

		},
		{
			key: 'oldPriceUzs',
			label: i18n.t('prices.item.lastPriceUzs'),
			'class': 'width6Percent',
		},
		{
			key: 'price',
			label: i18n.t('prices.item.sum-new'),
		}
	],
	references: [],
	refChildren: [],
	bankCardPaymentMethods: [],
	refCurrencies: [],
	subRefChildren: [],
	subRefChildren2: [],
	subRefChildren3: [],
	categoryChildren: [],
	countryChildren: [],
	raionulChildren: [],
	groupChildren: [],
	allPaymentMethods: [],
	refParentResponse: '',
	refChildResponse: '',
	notAllowedError: false,
	deleteRefErrorMessage: '',
	addRefError: false,
	addRefErrorMessages: [],
	refPaymentType: [],

};

const getters = {
	getReferences: (state) => {
		return state.references;
	},
	getRefChildren: (state) => {
		return state.refChildren;
	},
	getSubRefChildren: (state) => {
		return state.subRefChildren;
	},
	getCategoryChildren: (state) => {
		let obj = {};
		obj.items = state.categoryChildren;
		obj.value = null;
		return obj;
	},
	getGroupChildren: (state) => {
		let obj = {};
		obj.items = state.groupChildren;
		obj.value = null;
		return obj;
	},
	getRaionulChildren: (state) => {
		let obj = {};
		obj.items = state.raionulChildren;
		obj.value = null;
		return obj;
	},
	getCountryChildren: (state) => {
		let obj = {};
		obj.items = state.countryChildren;
		obj.value = null;
		return obj;
	}
}


const actions = {
	async getReferencesList ({ commit }) {
		try {
			const references = await ReferencesService.getReferences();
			commit('setReferences', references.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getReferenceChildren ({ commit }, parentCode) {
		try {
			const refChildren = await ReferencesService.getReferenceChildren(parentCode);
			commit('setReferenceChildren', { data: refChildren.data, parentCode });
			return true
		} catch (e) {
			return false
		}
	},
	async getSubReferenceChildren ({ commit }, idAndChild) {
		try {
			const refChildren = await ReferencesService.getSubReferenceChildren(idAndChild.id);
			commit('setSubReferenceChildren', { data: refChildren.data, childNumber: idAndChild.child });
			return true
		} catch (e) {
			return false
		}
	},
	async deleteRef ({ commit }, idAndRefType) {
		try {
			const deleteResponse = await ReferencesService.deleteRef(idAndRefType.id);
			commit('deleteRefFromStore', { deleteResponse, idAndRefType });
			return true;
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('deleteRefError', { message: response.message, boolean: true });
			return false;
		}
	},
	async updateOrCreateRefParent ({ commit }, payload) {
		try {
			const updateResponse = await ReferencesService.updateOrCreateRefParentById(payload);
			commit('updateOrCreateRefParentCommit', updateResponse.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('addRefError', { message: response.message, boolean: true });
			return false;
		}
	},
	async updateOrCreateRefChild ({ commit }, payload) {
		try {
			const updateResponse = await ReferencesService.updateOrCreateRefChildById(payload);
			commit('updateOrCreateRefChildCommit', updateResponse.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('addRefError', { message: response.message, boolean: true });
			return false;
		}

	},
	async loadPaymentMethods ({ commit }) {
		try {
			const response = await ReferencesService.getPaymentMethods();
			await commit('setPaymentMethods', response.data);
		} catch (e) {
			return false;
		}
	}
};

const mutations = {
	setReferences (state, references) {
		state.references = references;
	},
	setReferenceChildren (state, payload) {
		if (payload.parentCode) {
			if (payload.parentCode.toUpperCase() == 'CONTRAGENT_CATEGORY') {
				state.categoryChildren = payload.data
			}
			else if (payload.parentCode.toUpperCase() == 'CONTRAGENT_GROUPS') {
				state.groupChildren = payload.data
			}
			else if (payload.parentCode.toUpperCase() == 'CITIZEN') {
				state.countryChildren = payload.data
			}
			else if (payload.parentCode.toUpperCase() == 'CURRENCY') {
				state.refCurrencies = payload.data;
			}
			else if (payload.parentCode.toUpperCase() == 'BANK_CARD') {
				state.bankCardPaymentMethods = payload.data;
			}
			else if (payload.parentCode.toUpperCase() == 'PROMOTION_TYPE') {
				state.refPaymentType = payload.data
			}
			else if (payload.parentCode == 'Raionul') {
				state.raionulChildren = payload.data
			}
		}
		// state.refChildren = payload.data;
		payload.parentCode.toUpperCase() == 'CURRENCY' ? '' : state.refChildren = payload.data;
	},
	setSubReferenceChildren (state, payload) {
		if (payload.childNumber == 1) {
			state.subRefChildren = payload.data;
		} else if (payload.childNumber == 2) {
			state.subRefChildren2 = payload.data;
		} else if (payload.childNumber == 3) {
			state.subRefChildren3 = payload.data;
		}
	},
	resetReferences (state) {
		state.references = [];
	},
	resetRefChildren (state) {
		state.refChildren = [];
	},
	updateOrCreateRefParentCommit (state, updateResponse) {
		state.refParentResponse = updateResponse
	},
	updateOrCreateRefChildCommit (state, updateResponse) {
		state.refChildResponse = updateResponse
	},
	deleteRefFromStore (state, obj) {
		let idAndRefType = obj.idAndRefType;
		if (obj.deleteResponse) {
			if (idAndRefType.type == 'child') {
				let foundIndex = state.refChildren.findIndex(x => x.id == idAndRefType.id);
				state.refChildren.splice(foundIndex, 1);
			} else {
				let foundIndex = state.references.findIndex(x => x.id == idAndRefType.id);
				state.references.splice(foundIndex, 1);
			}
		}
	},
	deleteRefError (state, payload) {
		state.notAllowedError = payload.boolean;
		state.deleteRefErrorMessage = payload.message;
	},
	addRefError (state, payload) {
		state.addRefError = payload.boolean;
		state.addRefErrorMessages = Array.isArray(payload.message) ? payload.message : [payload.message];
	},
	setPaymentMethods (state, payload) {
		state.allPaymentMethods = payload;
	}
};

export const references = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
